// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MainWindowManager } from '../../UtilsClasses/MainWindowManager';
import { Resources } from '@shared/localizations/Resources';
import { QuickTreeNode } from '../QuickTree/QuickTreeNode';
import { TerceraLookupDropDownForm } from './TerceraLookupDropDownForm';
import { ThemeManager } from '../../misc/ThemeManager';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import TerceraAccountLookupDropDownFormTemplate from '@front/templates/TerceraAccountLookupDropDownFormTemplate.html';
import { LookupDropDownDefaults } from '../../UtilsClasses/LookupDropDownDefaults';
export class TerceraAccountLookupDropDownForm extends TerceraLookupDropDownForm {
    constructor() {
        super(...arguments);
        this.noRaiseSelectAll = false;
        this.modBtnText = 'Select';
        this.onMultiSelectChanged = (event) => {
            const checked = event.currentTarget.checked;
            void this.set('isMultiSelect', checked);
            if (this.quickTree.quickTree.UseCHB) {
                this.quickTree.quickTree.isMultiSelectCheckboxUsing = checked;
            }
            else {
                this.quickTree.quickTree.isMultiSelect = checked;
            }
            this.quickTree.quickTree.Draw();
        };
        this.onCheckAllStateChange = (event) => {
            if (this.noRaiseSelectAll) {
                this.noRaiseSelectAll = false;
                return;
            }
            const newChekedState = event.currentTarget.checked;
            void this.set('checkedSelectedAll', newChekedState);
            if (!isNullOrUndefined(this.quickTree)) {
                if (this.quickTree.quickTree.isMultiSelectCheckboxUsing) {
                    this.quickTree.quickTree.CheckUnCheckAllMultiCheckbox(newChekedState);
                }
                else {
                    this.quickTree.quickTree.CheckUnCheckAll(newChekedState);
                }
            }
        };
    }
    getType() {
        return 'TerceraAccountLookupDropDownForm';
    }
    initializationComponents() {
        this.textBox = this.Controls.textBox;
        const qtr = this.Controls.quickTree;
        if (!isNullOrUndefined(qtr === null || qtr === void 0 ? void 0 : qtr.quickTree)) {
            this.quickTree = qtr;
        }
    }
    static ShowForm(parametersStruct) {
        return __awaiter(this, void 0, void 0, function* () {
            if (MainWindowManager.TerceraAccountLookupDropDownForm == null) {
                MainWindowManager.TerceraAccountLookupDropDownForm =
                    yield TerceraAccountLookupDropDownForm.createInstance();
            }
            void MainWindowManager.TerceraAccountLookupDropDownForm.showForm(parametersStruct);
        });
    }
    fillTree() {
        var _a;
        const items = this.items;
        let selectedItem = [];
        if (Array.isArray(this.selectedItem)) {
            selectedItem = this.selectedItem;
        }
        else {
            selectedItem.push(this.selectedItem);
        }
        const selectedNodes = [];
        const nodeArr = [];
        const groupNodeDict = {};
        const userNodeDict = {};
        const linkedAccountsNode = new QuickTreeNode(Resources.getResource('TerceraAccountLookup.Linked accounts'));
        linkedAccountsNode.collapsed = false;
        linkedAccountsNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconLinkedAccountsCollapsed.image;
        linkedAccountsNode.collapsedImageSelected =
            ThemeManager.NewImages.quickTreeIconLinkedAccountsCollapsedSelected.image;
        linkedAccountsNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconLinkedAccountsExpanded.image;
        linkedAccountsNode.expandedImageSelected =
            ThemeManager.NewImages.quickTreeIconLinkedAccountsExpandedSelected.image;
        const isAdmin = RulesSet.TERMINAL_HTML;
        if (isNullOrUndefined(items)) {
            return;
        }
        const len = items.length;
        for (let i = 0; i < len; i++) {
            const account = items[i];
            if (!this.showMAM && account.isMAM) {
                continue;
            }
            const userLogin = account.UserLogin;
            const groupName = account.UserGroupName;
            const accountToString = account.toString(true);
            // Filtering.
            if (this.currentNameFilter !== null) {
                const curItemFindStr = accountToString.toLowerCase();
                const filterString = this.currentNameFilter.toLowerCase();
                if (curItemFindStr.indexOf(filterString) === -1) {
                    continue;
                }
            }
            const accountNode = new QuickTreeNode(accountToString);
            const isAccountItemAll = (_a = selectedItem[0]) === null || _a === void 0 ? void 0 : _a._AccountItemAll;
            if (selectedItem.includes(account) || isAccountItemAll) {
                selectedNodes.push(accountNode);
            }
            accountNode.tag = account;
            accountNode.visible = !account.isHide;
            accountNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconAccountCollapsed.image;
            accountNode.collapsedImageSelected = ThemeManager.NewImages.quickTreeIconAccountCollapsedSelected.image;
            accountNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconAccountExpanded.image;
            accountNode.expandedImageSelected = ThemeManager.NewImages.quickTreeIconAccountExpandedSelected.image;
            let groupNode = null;
            if (isAdmin && groupName) {
                groupNode = groupNodeDict[groupName];
                if (!groupNode) {
                    groupNode = new QuickTreeNode(groupName);
                    groupNode.collapsed = false;
                    groupNode.collapsedImageDef = ThemeManager.NewImages.quickTreeIconUserGroupCollapsed.image;
                    groupNode.collapsedImageSelected =
                        ThemeManager.NewImages.quickTreeIconUserGroupCollapsedSelected.image;
                    groupNode.expandedImageDef = ThemeManager.NewImages.quickTreeIconUserGroupExpanded.image;
                    groupNode.expandedImageSelected =
                        ThemeManager.NewImages.quickTreeIconUserGroupExpandedSelected.image;
                    groupNodeDict[groupName] = groupNode;
                    nodeArr.push(groupNode);
                }
            }
            if (account.isLinked) {
                linkedAccountsNode.AddChildNode(accountNode);
            }
            else if (userLogin) {
                let userNode = userNodeDict[userLogin];
                if (isNullOrUndefined(userNode)) {
                    userNode = new QuickTreeNode(userLogin);
                    userNode.collapsed = false;
                    userNodeDict[userLogin] = userNode;
                    if (!isNullOrUndefined(groupNode)) {
                        groupNode.AddChildNode(userNode);
                    }
                    else {
                        nodeArr.push(userNode);
                    }
                }
                userNode.AddChildNode(accountNode);
            }
            else {
                nodeArr.push(accountNode);
            }
        }
        TerceraAccountLookupDropDownForm.sortNodes(nodeArr);
        if (linkedAccountsNode.childNodes.length > 0) {
            nodeArr.push(linkedAccountsNode);
        }
        this.quickTree.quickTree.Clear();
        const [singleNode] = nodeArr;
        const hasSingleNodeWithChildren = nodeArr.length === 1 && singleNode.childNodes.length > 0;
        this.quickTree.quickTree.AddNodeRange(hasSingleNodeWithChildren ? singleNode.childNodes : nodeArr);
        const ims = this.quickTree.quickTree.isMultiSelectCheckboxUsing;
        for (let i = 0; i < selectedNodes.length; i++) {
            if (ims) {
                this.quickTree.quickTree.setCheckedNode(selectedNodes[i]);
            }
            else {
                this.quickTree.quickTree.setSelectedNode(selectedNodes[i], true);
            }
        }
        this.quickTree.quickTree.goToSelectedNode();
        this.quickTree.setSizes();
    }
    static sortNodes(nodes) {
        if (isNullOrUndefined(nodes))
            return;
        nodes.sort(TerceraAccountLookupDropDownForm.sortItems);
        const len = nodes.length;
        for (let i = 0; i < len; i++) {
            TerceraAccountLookupDropDownForm.sortNodes(nodes[i].childNodes);
        }
    }
    static sortItems(i1, i2) {
        const acc1 = i1.tag;
        const acc2 = i2.tag;
        if (isNullOrUndefined(acc1) || isNullOrUndefined(acc2)) {
            return i1.nodeText.toLowerCase().localeCompare(i2.nodeText.toLowerCase());
        }
        if (acc1.isLinked && !acc2.isLinked) {
            return 1;
        }
        else if (!acc1.isLinked && acc2.isLinked) {
            return -1;
        }
        else {
            return acc1.FullAccString.toLowerCase().localeCompare(acc2.FullAccString.toLowerCase());
        }
    }
    localize() {
        super.localize();
        this.modBtnText = Resources.getResource('TerceraAccountLookup.Select');
    }
    static createInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            const lookup = new TerceraAccountLookupDropDownForm();
            lookup.setBounds(0, 0, LookupDropDownDefaults.width, LookupDropDownDefaults.height);
            void lookup.set('visible', false);
            const currentMainWindow = MainWindowManager.MainWindow;
            currentMainWindow.addControl(lookup);
            lookup.observe('isMultiSelect', lookup.isMultiSelectObserver);
            return yield lookup.OnCompliteWaiter;
        });
    }
    isMultiSelectObserver(newVal) {
        var _a;
        void this.set({ isShowFooterBtn: newVal }).then(() => {
            this.resizeOnFooterChangeVisibility();
        });
        // Part of dark magic
        if (!isNullOrUndefined((_a = this.quickTree) === null || _a === void 0 ? void 0 : _a.quickTree)) {
            this.quickTree.quickTree.isMultiSelectCheckboxUsing = newVal;
        }
        if (!isNullOrUndefined(this.caller)) {
            this.caller.isMultiSelect = newVal;
            this.caller.items = this.caller.multiSelectDropDownItems;
            this.items = this.caller.multiSelectDropDownItems;
        }
        if (isValidArray(this.items)) {
            this.fillTree();
        }
    }
    resizeOnFooterChangeVisibility() {
        if (isNullOrUndefined(this.quickTree)) {
            return;
        }
        void this.quickTree.resetSizes().then(() => {
            this.quickTree.setSizes();
        });
    }
    selectionChanged() {
        super.selectionChanged();
        const qt = this.quickTree.quickTree;
        if (!isValidArray(this.items) || isNullOrUndefined(qt)) {
            return;
        }
        const selectedNum = Object.keys(qt.selectedNodesDict).length;
        const selectedAll = selectedNum === this.items.length;
        if (this.get('isShowFooterBtn')) {
            if (this.get('checkedSelectedAll') !== selectedAll) {
                // select all cb checked state changed
                this.noRaiseSelectAll = true;
            }
            void this.set({ checkedSelectedAll: selectedAll });
        }
    }
}
TerceraLookupDropDownForm.extendWith(TerceraAccountLookupDropDownForm, {
    partials: { bodyPartial: TerceraAccountLookupDropDownFormTemplate }
});
